import FormGroup from '../../../generic/FormGroup';
import translations from '../../../../translations';
import InputOrValuePicker from '../../../generic/InputOrValuePicker';
import type { ValueElementIdAPI } from '../../../../types/value';
import type { Agent } from '../../../../types/graph';

interface Props {
    value: string | ValueElementIdAPI | null;
    onChange: (agent: Partial<Agent>) => void;
    hasSubmitted: boolean;
    label?: string;
    validationMessage?: string;
    container: HTMLElement | null;
}

const AgentMessage = ({
    value,
    onChange,
    hasSubmitted,
    label,
    validationMessage,
    container,
}: Props) => {
    return (
        <FormGroup
            label={label || translations.AGENT_message_label}
            isRequired={true}
            isValid={!!value}
            showValidation={hasSubmitted}
            validationMessage={validationMessage || translations.AGENT_message_required}
            htmlFor="agent-message"
        >
            <InputOrValuePicker
                value={value}
                onChangeAsValueReference={(value) =>
                    onChange({
                        message: value
                            ? {
                                  id: value.id,
                                  command: value.command,
                                  typeElementPropertyId: value.typeElementPropertyId,
                              }
                            : null,
                    })
                }
                includeSystemValues={false}
                container={container}
            >
                <textarea
                    id="agent-message"
                    data-testid="agent-message"
                    className="form-control form-textarea"
                    value={(value as string) || ''}
                    onChange={(e) => {
                        onChange({ message: e.currentTarget.value });
                    }}
                    rows={3}
                />
            </InputOrValuePicker>
        </FormGroup>
    );
};

export default AgentMessage;
